import { NeoState } from '../Reducers.interface';

export const selectBookingSummaryForEvent = (eventId: string) => (state: NeoState) =>
  state.bookings.bookingSummary[eventId];
